const messages = {
    nl: {
        message: {
            locationPois: 'POIS van de locatie',
            scenarioNotSelected: 'Geen scenario geselecteerd',
            scenarioNotCalculated: 'Scenario is niet doorgerekend',
            locationNotSelected: 'Geen locatie geselecteerd',
            catchmentAreaNotSelected: 'Geen verzorgingsgebied geselecteerd',

            exportMapToPng: 'Exporteer kaart naar PNG',
            satelliteView: 'Satelliet',
            showLocationOutput: 'Modeluitkomst per locatie',
            googleStreetView: 'Google Streetview',
            googleMaps: 'Google Maps',

            refresh: 'Ververs',
            selectedScenario: 'Geselecteerde scenario',
            submodel: 'Submodel',
            confirmCalculateScenario: 'Het scenario is gewijzigd. Wilt u het scenario doorrekenen?',
            search: 'Zoeken op de kaart',
            scenarioNameAutomaticallyChangedNotificaton: 'De naam van het scenario is automatisch aangepast omdat er nog maar 1 wijziging was.',
            scenarioDeletedBecauseEmptyNotificaton: 'Het scenario had geen wijzigingen meer en is daarom verwijderd.',
            setScenarioNameMessage: 'Omdat je een meervoudig scenario maakt, is het verplicht de naam van het scenario op te geven.',
            setScenarioName: 'Scenario naam',
            saveAddToNewScenario: 'Opslaan (in nieuw scenario)',
            saveAddToThisScenario: 'Opslaan (in huidige scenario)',
            saveAddToNewNestedScenario: 'Opslaan (in nieuw genest scenario)',
            saveEditInNewScenario: 'Opslaan (in nieuw scenario)',
            saveEditInThisScenario: 'Opslaan (in huidige scenario)',
            saveEditInNewNestedScenario: 'Opslaan (in nieuw genest scenario)',
            cancel: 'Annuleren',
            closeMessage: 'Je staat op het punt de locatie te sluiten.',
            closeLocation: 'Locatie sluiten',
            closeLocationInNewScenario: 'Locatie sluiten (in nieuw scenario)',
            closeLocationInThisScenario: 'Locatie sluiten (in huidig scenario)',
            closeLocationInNewNestedScenario: 'Locatie sluiten (in nieuw genest scenario)',
            calculateThisScenario: "Doorrekenen huidige scenario",


            nameRequired: 'Naam is verplicht',
            scenarioLocationsVisibleOnMap: 'Locaties van scenarios',
            scenarios: 'Scenarios',
            errorOccured: 'Er heeft zich een onverwachte fout voorgedaan, mogelijk als gevolg van een slechte internetverbinding. Klik de ververs knop om de applicatie opnieuw te laden.',
            noTopScenariosFound: 'Er zijn geen top scenarios gevonden. Maak een nieuwe top scenario aan of pas een bestaand scenario aan zodat deze top scenario is.',
            filterScenarios: 'Zoeken naar/binnen scenarios',
            locationInDefaultScenario: 'U kunt het default scenario niet aanpassen. Als u doorgaat wordt de locatie aangemaakt in een nieuw scenario met dezelfde naam als de locatie. Wilt u doorgaan?',
            generatedOn: 'Gegenereerd op',
            foundLocations: 'Gevonden locaties',
            of: 'van',
            page: 'Pagina',
            selectAll: 'alles',
            selectNone: 'geen',
            heatMaps: 'Warmtekaart',
            print: 'Afdrukken',
            no: 'Nee',
            yes: 'Ja',
            copyChangesInformation: 'Hieronder kunt u aangeven welke locaties worden gekopieerd naar het doel scenario.',
            locations: 'Locaties',
            copyChanges: 'Wijzigingen kopiëren',
            uploadLocationsCsv: 'CSV uploaden',
            exportAreas: 'Gebieden exporteren',
            exportAreasDialogTitle: 'Gebieden exporteren',
            exportAreasInformation: 'Exporteer de centroïden van alle gebieden die voldoen aan onderstaande filters. Gebruik het export-formaat in het menu om CSV of XLSX te kiezen.',
            exportAreasAreaSet: 'Gebiedenset',
            exportAreasFilters: 'Filters op gebiedeigenschappen (AND)',
            exportAreasAddFilter: 'Filter toevoegen',
            exportAreasRemoveFilter: 'Filter verwijderen',
            exportAreasProperty: 'Eigenschap',
            exportAreasMinValue: 'Minimum',
            exportAreasMaxValue: 'Maximum',
            exportAreasNoNumericProperties: 'Deze gebiedenset heeft geen numerieke eigenschappen om op te filteren.',
            exportAreasRangeHint: 'Bereik in dataset: {min} – {max}',
            exportAreasTooManyRows: 'Export niet mogelijk: {count} rijen overschrijdt de limiet van 100.000. Pas de filters aan.',
            exportAreasRowCountConfirm: 'Deze export levert {count} rijen op. Wilt u doorgaan?',
            exportAreasIncludeValues: 'Inclusief gebiedeigenschappen',
            exportAreasIncludeValuesHint: 'Uit = sneller: alleen Naam, Longitude, Latitude en AreaCode worden geëxporteerd.',
            exportAreasButton: 'Exporteren',
            uploadLocationsCsvInformation: 'Upload een CSV met kolommen Name, Longitude, Latitude, LocationGroup. Corrigeer ontbrekende naam of locatiegroep in de tabel.',
            uploadLocationsCsvEmpty: 'Het CSV-bestand is leeg.',
            uploadLocationsCsvNoRows: 'Geen geldige rijen gevonden in het CSV-bestand.',
            uploadLocationsCsvMissingColumns: 'Het CSV-bestand mist de Longitude of Latitude kolom.',
            uploadLocationsCsvInvalidRows: '{count} rij(en) hebben een ontbrekende naam of locatiegroep.',
            uploadLocationsCsvDetectedProperties: 'Locatie-eigenschappen herkend uit CSV: {names}. Pas de waarden aan in de tabel indien nodig.',
            uploadLocationsCsvCultureMismatch: 'Het CSV-bestand lijkt in {detected} te zijn, maar {selected} is geselecteerd. Pas de CSV taalinstelling aan indien nodig.',
            selectCsvFile: 'Selecteer CSV-bestand',
            bulkUploadScenarioName: 'Nieuwe locaties',
            required: 'Verplicht',
            longitude: 'Lengtegraad',
            latitude: 'Breedtegraad',
            locationGroup: 'Locatiegroep',
            nonShared: 'Niet gedeeld',
            sharedWith: 'Gedeeld met',
            shared: 'Gedeeld',
            otherLocations: 'andere locaties',
            mergeScenarioSource: 'De volgende wijzigingen zullen worden samengevoegd in het opgegeven scenario.',
            targetScenario: 'Doel scenario',
            deleteSourceScenario: 'Verwijder het bron scenario',
            scenarioCompetition: 'Locaties in dit scenario concureren met elkaar.',
            competitionDescription: 'Hiermee geef je aan of nieuwe vestigingen in het scenario met elkaar moeten concureren.',
            isTopScenarioDescription: 'Een top scenario zorgt er voor dat het scenario als eerste en vet gedrukt wordt weergegeven in de lijst met scenarios.',
            mergeScenario: 'Scenario samenvoegen',
            isTopScenario: 'Top scenario',
            confirmClose: 'Weet u zeker dat u dit scherm wilt sluiten?',
            displayName: 'Weergave naam',
            email: 'E-mail adres',
            mobilePhone: 'Mobiel telefoonnummer',
            calculationModel: 'Calculation model',
            calculateUnprocessedScenarios: 'Doorrekenen onverwerkte scenarios',
            log: 'Log',
            usage: 'Gebruiksstatistieken',
            usageDescription: 'Toont activiteit per groep. Selecteer een of meer groepen en een datumbereik om gebruik per actietype te zien. Optioneel filteren op een of meer modellen.',
            groups: 'Gebruikersgroepen',
            models: 'Modellen',
            users: 'Gebruikers',
            filter: 'Filter',
            dateRange: 'Periode',
            count: 'Aantal',
            distinctUsers: 'Unieke gebruikers',
            distinctActions: 'Unieke acties',
            groupBy: 'Groeperen op',
            unknown: 'Onbekend',
            noUsageData: 'Geen gebruiksgegevens gevonden voor deze selectie.',
            allActions: 'Alle acties',
            usageAction_fetchModel: 'Model openen',
            usageAction_selectLocation: 'Locatie selecteren',
            usageAction_calculate: 'Doorrekenen',
            usageAction_createLocation: 'Locatie aanmaken',
            usageAction_updateLocation: 'Locatie wijzigen',
            usageAction_deleteLocation: 'Locatie verwijderen',
            usageAction_createScenario: 'Scenario aanmaken',
            usageAction_updateScenario: 'Scenario wijzigen',
            usageAction_deleteScenario: 'Scenario verwijderen',
            warning: 'Waarschuwing',
            eventType: 'Type',
            source: 'Bron',
            message: 'Bericht',
            fetchIsoLine: 'Isolijn ophalen',
            isoLine: 'Isolijn',
            scheduledDateTimeUtc: 'Gepland',
            isoLinesMissingDateTimeUtc: 'Missende rijtijden',
            startedDateTimeUtc: 'Start',
            endedDateTimeUtc: 'Einde',
            noMatchingLocations: 'Geen overeenkomstige locaties',
            scenarioNameIsRequired: 'Scenario naam is verplicht',
            parentScenario: 'Bron scenario',
            sourceLocations: 'Bron locaties',
            sourceLocationsAllScenarios: 'Bron locaties alle scenarios',
            driverFilterFunction: 'Functie',
            driverFilterTitle: 'Titel',
            addDriver: 'Verklaring toevoegen',
            addDriverFilter: 'Groep toevoegen',
            confirmRemoveScenario: 'Weet u zeker dat u dit scenario wilt verwijderen?',
            confirmRemoveLocation: 'Weet u zeker dat u deze locatie wilt verwijderen?',
            confirmUndoCloseLocation: 'Weet u zeker dat u de sluiting van deze locatie ongedaan wilt maken?',
            confirmUndoEditLocation: 'Weet u zeker dat u de bewerkingen van deze locatie ongedaan wilt maken?',
            editScenario: 'Bewerken',
            removeScenario: 'Verwijderen',
            calculateScenario: 'Doorrekenen',
            filterAndSearch: 'Locaties',
            map: 'Kaart',
            matchingPercentage: '% Overeenkomst',
            drawerNotCalculated: 'Het model is niet doorgerekend. Daardoor zijn de resultaten niet zichtbaar.',
            drawerCalculating: 'Het model is aan het rekenen. Wacht tot de resultaten zichtbaar worden.',
            legend: 'Legenda',
            modelAdmin: 'Model eigenaar',
            globalAdmin: 'Beheerder',
            owner: 'Eigenaar',
            ownerOnly: 'Alleen voor Eigenaars',
            noChanges: 'Er zijn nog geen openingen of sluitingen.',
            name: 'Naam',
            query: 'Zoek-tekst',
            coordinatesOrUrl: 'Coördinaten of kaart-URL',
            coordinatesOrUrlHint: 'bijv. 52.3676, 4.9041 of een Google / OSM / Bing / HERE link',
            invalidLocation: 'Kon geen coördinaat uit deze invoer lezen',
            export: 'Exporteer',
            noDrivers: 'Er zijn geen verklaringen gedefinieerd voor dit model.',
            condition: 'Voorwaarde',
            roundingDigits: 'Decimalen',
            inverse: 'Achterstevoren',
            drivers: 'Verklaringen',
            report: 'rapport',
            matchingLocationsOutputChart: 'Resultaten diagram',
            matchingLocationsSimilarityChart: 'Overeenkomsten diagram',
            driversChart: 'Verklaring diagram',
            disclaimer: 'Disclaimer',
            disclaimerContent: 'De ontwikkeling van IRIS is gebaseerd op wetenschappelijke methoden, actuele verkooppunt informatie en zorgvuldig onderzochte en up-to-date klantinformatie. Het model wordt zo goed mogelijk gevalideerd op basis van de actuele omzetten die in de markt worden gerealiseerd en informatie over het functioneren van de markt. Ieder wiskundig model, hoe gedetailleerd ook in de uitwerking, is een vereenvoudigde weergave van de werkelijkheid en zal nooit 100% correct zijn. Aan de uitkomsten kunnen daarom geen rechten worden ontleend.',
            help: 'Handleiding',
            csvExport: 'Export data',
            exportFormat: 'Exportformaat',
            csv: 'CSV',
            xlsx: 'XLSX',
            fileFormatCulture: 'CSV taalinstelling',
            dutchFormat: 'Nederlands formaat',
            englishFormat: 'Engels formaat',
            areaInformation: 'Gebiedsinformatie',
            areaInformationCatchmentArea: 'Gebiedsinformatie verzorgingsgebied',
            adminPages: 'Admin',
            locationAreas: 'Gebieden van de locatie',
            adminOnly: 'Alleen voor beheerders (WERKT NOG NIET)',
            
            scenarioProcessingLog: 'Verwerkingslogboek',
            calculationScheduled: 'Verwerking ingepland',
            calculationWaitingForIsolines: 'Verwerking wacht op isochronen',
            calculationStarted: 'Verwerking start',
            calculationEnded:'Verwerking einde',
            calculationScenarioError: 'Verwerking fout (scenario)',
            calculationModelError: 'Verwerking fout (model)',
            isolinesStarted: 'Isochronen ophalen start',
            isolinesEnded: 'Isochronen ophalen einde',
            isolinesError: 'Isochronen ophalen fout',
            isolinesBusy: 'Isochronen ophalen bezig',
            dateAndTime: 'Datum en tijd',
            action: 'Actie',
            model: 'Model',
            user: 'Gebruiker',
            last100records: 'Laatste 100 records',
            propertiesChart: 'XY grafiek',
            propertyX: 'Eigenschap op X as',
            propertyY: 'Eigenschap op Y as',
            tree: 'boom | bomen',
            applicationTitle: 'IRIS',
            title: 'Titel',
            logout: 'Afmelden',
            login: 'Aanmelden',
            share: 'Aandeel',
            area: 'Gebied | Gebieden',
            personType: 'Persona',
            inhabitants: 'Inwoners',
            houseHolds: 'Huishoudens',
            income: 'Inkomen',
            areaRevenuePerYear: 'Besteding in postcode per jaar',
            areaRevenuePerPeriod: 'Besteding in postcode per periode',
            areaStandardConsumers: 'Standaard consumenten in postcode',
            total: 'Totaal',
            travelTimeScores: 'Aantrekkelijkheden reistijd',
            from: 'vanaf',
            calculation: 'Berekening',
            perYear: 'Per jaar',
            catchmentArea: 'Verzorgingsgebied',
            outputSpending: 'Besteding',
            outputNumber: 'Aantal',
            car: 'Auto',
            pedestrian: 'Voetganger',
            scorePersonType: 'Aantrekkelijkheid persona',
            calculated: 'Berekend',
            location: 'Locatie',
            value: 'Waarde',
            defaultValue: 'Standaard waarde',
            expression: 'Functie',
            format: 'Formule',
            scoresLocationGroup: 'Aantrekkelijkheden formule',
            scoresShop: 'Aantrekkelijkheden winkel',
            scoresRetailArea: 'Aantrekkelijkheden winkelgebied',
            retailArea: 'Winkelgebied',
            changedLocations: 'Wijzigingen',
            opening: 'Opening',
            closure: 'Sluiting',
            edited: "Aangepast",
            edit: "Bewerk",
            addScenario: 'Scenario toevoegen',
            infoScenario: 'Scenario informatie',
            calculate: 'Doorrekenen',
            add: 'Toevoegen',
            info: 'Informatie',
            scenarioCreated: 'Aanmaakdatum',
            scenarioModified: 'Bewerkdatum',
            scenarioCreatedBy: 'Aangemaakt door',
            scenarioModifiedBy: 'Bewerkt door',
            scenario: 'Scenario',
            scenarioReport: 'Impact rapport',
            scenarioName: 'Scenario naam',
            save: 'Opslaan',
            error: 'Fout',
            url: 'URL',
            status: 'Status',
            description: 'Omschrijving',
            settings: 'Instellingen',
            new: 'Nieuw',
            modelParameters: 'Model parameters',
            none: 'Geen',
            editModelParameters: 'Bewerk model parameters',
            editDrivers: 'Bewerk verklaringen',
            propertyType: 'Type',
            drawerEmptyText: 'Klik op een locatie op de kaart om informatie weer te geven.',
            score: 'Aantrekkelijkheid | Aantrekkelijkheden',
            information: 'Informatie',
            graphics: 'Grafieken',
            layers: 'Lagen',
            all: 'Alles',
            primary: 'Primair (50%)',
            secondary: 'Secundair (80%)',
            impact: 'Impact',
            impactCar: 'Impact auto',
            impactPedestrian: 'Impact voetganger',
            display: 'Weergave',
            top10: 'Top 10',
            top25: 'Top 25',
            top: 'Top',
            fraction: 'Aandeel',
            fractionCumulative: 'Aandeel (cumulatief)',
            showTravelTimes: 'Reistijd weergeven',
            travelTimes: 'Reistijd',
            minutes: 'Minuten',
            group: 'Gebruikersgroep',
            property: 'Eigenschap',
            expressions: 'Formules',
            powerFactor: 'Machtsfactor',
            constant: 'Constante',
            scale: 'Schaal',
            max: 'Maximum',
            by: "door",
            fractionCutOffThreshold: 'Fractie drempel waarde',
            differenceDefaultScenario: 'Verschil t.o.v. standaard scenario',
            reports: 'Rapportage',
            locationsType1Name: 'Vestiging | Vestigingen',
            locationsType2Name: 'Winkelgebied | Winkelgebieden',
            locationsType1FilterLocations: 'Filter op vestiging van het scenario',
            locationsType2FilterLocations: 'Filter op winkelgebied van het scenario',
            googleSearch: 'Zoeken op de kaart',
            locationType1Scores: 'Aantrekkelijkheden vestiging',
            locationType2Scores: 'Aantrekkelijkheden winkelgebied',
            areaScores: 'Aantrekkelijkheden reistijd',
            locationsType1Impact: 'Impact per vestiging (top 25)',
            locationsType2Impact: 'Impact per winkelgebied (top 25)',
            locationGroupsType1Name: 'Formule',
            locationGroupsType2Name: 'Winkelgebied soort',
            locationsGroupsType1Impact: 'Impact per formule (top 10)',
            locationsGroupsType2Impact: 'Impact per winkelgebied soort (top 10)',
            locationsClustersType1Impact: 'Impact per winkelgebied (top 10)',
            locationsClustersType2Impact: 'Impact per gemeente (top 10)',
            locationsClustersType1EmptyName: '',
            locationsClustersType2EmptyName: '',
            locationsGroupsType1EmptyName: 'Zelfstandig',
            locationsGroupsType2EmptyName: '',
            locationClustersType1Name: 'Winkelgebied',
            locationClustersType2Name: 'Gemeente',
            outputType1Name: "Omzet per week",
            outputType2Name: "Standaard consumenten",
            outputType3Name: "Omzet per jaar",
            outputType4Name: "Standaard consumenten",
            areasType1Name: "Postcode | Postcodes",
            areasType2Name: "Statistische sector | Statisische sectoren",
            locationsType1New: "Nieuwe vestiging hier",
            locationsType2New: "Nieuwe winkelgebied hier",
            close: "Sluiten",
            delete: "Verwijderen",
            undoClose: "Sluiten ongedaan maken",
            undoEdit: "Bewerking ongedaan maken",
            modelFunctionTypeToUse: "Het is mogelijk de volgende velden te gebruiken:",
            ncalcMessage: "De functies maken gebruik van de NCalc bibliotheek. Kijk op https://github.com/ncalc/ncalc voor meer informatie.",
            calculationModelOutput: "Model resultaten",
            locationsOutput: 'Locations',
            scenarioLocationsOutput: 'Resultaten',
            modelScenarioLocationsOutput: 'Model resultaten',
            scenarioLocations: 'Locaties',
            scenarioLocationsAllScenarios: 'Locaties van alle scenarios',
            scenarioLocationsOutputDescription: 'Resultaten van het geselecteerde scenario',
            modelScenarioLocationsOutputDescription: 'Resultaten van alle verwerkte scenarios',
            scenarioLocationsOutputDescriptionWithHidden: 'Resultaten van het geselecteerde scenario alle velden',
            locationsOutputDescription: 'Locations.csv',
            catchmentAreaInformationExport: "Verzorgingsgebied van de geselecteerde locatie",
            areaInformationExport: "Gebied resultaat",
            areaInformationExportDescription: "Gebied resultaat van het geselecteerde gebied",
            weight: "Gewicht",
            editNormalizedScoresFunctions: "Bewerk functies genormaliseerde waarden",
            normalizedScoresFunctions: "Functies genormaliseerde waarden",
            before: "Voor",
            after: "Na",
            difference: "Verschil",
            localSituation: "Lokale situatie",
            dontShow: "Niet weergeven",
            pois: "POI's",
            poi: "POI",
            matchingLocations: "Vergelijkbare locaties",
            scenarioStatusEdited: "Bewerkt",
            scenarioStatusWaiting: "Wachten op verwerking",
            scenarioStatusProcessing: "Bezig met verwerken",
            scenarioStatusCompleted: "Verwerkt",
            scenarioStatusCompletedWithErrors: "Verwerkt met fouten",
            pleaseLogin: "Meld u aan via de knop aan de rechterbovenkant.",
            busyLoading: "Bezig met laden...",
            searchMap: "Zoeken op de kaart",
            unavailable: "Niet beschikbaar",
            show: "{item} weergeven",
            hide: "{item} verbergen",
            dependencies: 'Afhankelijkheden',
            agentIntro: "Hallo, ik ben je persoonlijke IRIS AI-Agent. Hoe kan ik je helpen?",
            agentQuestion: "Stel een vraag",
            agentTooltip: "Chat met de IRIS AI-Agent",
            agentDisclaimer: "Ik ben een AI-Agent en ik kan fouten maken. Controleer belangrijke informatie.",
            agentFilterAreasLocations: "Je kunt de gebieden en locaties op de kaart zien",
            agentFilterLocations: "Je kunt de locaties op de kaart zien",
            agentFilterAreas: "Je kunt de geselecteerde gebieden op de kaart zien",
            agentFilterAreaLocation: "Je kunt het gebied en de locatie op de kaart zien",
            agentFilterLocation: "Je kunt de locatie op de kaart zien",
            agentFilterArea: "Je kunt het geselecteerde gebied op de kaart zien",
            agentFilterAreasLocation: "Je kunt de gebieden en de locatie op de kaart zien",
            agentFilterAreaLocations: "Je kunt het gebied en de locaties op de kaart zien",
            agentRemoveFilter: "Ik heb de filters verwijderd"
        }
    },
    en: {
        message: {

            locationPois: 'POIS of the locations',
            scenarioNotSelected: 'No scenario selected',
            scenarioNotCalculated: 'Scenario is not calculated',
            locationNotSelected: 'No location selected',
            catchmentAreaNotSelected: 'No catchment area selected',

            exportMapToPng: 'Export map to PNG',
            satelliteView: 'Satellite',
            showLocationOutput: 'Show model output',
            googleStreetView: 'Google Streetview',
            googleMaps: 'Google Maps',
            refresh: 'Refresh',
            submodel: 'Submodel',
            confirmCalculateScenario: 'The scenario has changed. Do you want to calculate the scenario?',
            search: 'Search on the map',
            scenarioNameAutomaticallyChangedNotificaton: 'The name of the scenario is automatically changed because there was only 1 change left.',
            scenarioDeletedBecauseEmptyNotificaton: 'The scenario did not have any changes left so is deleted.',
            calculateThisScenario: "Calculate this scenario",
            setScenarioNameMessage: 'Since you are creating a multiple scenario, if it required to specify the name of the scenario.',
            setScenarioName: 'Scenario name',
            saveAddToNewScenario: 'Save (in new scenario)',
            saveEditInNewScenario: 'Save (in new scenario)',
            saveAddToThisScenario: 'Save (in current scenario)',
            saveEditInThisScenario: 'Save (in current scenario)',
            saveAddToNewNestedScenario: 'Save (in new nested scenario)',
            saveEditInNewNestedScenario: 'Save (in new nested scenario)',
            cancel: 'Cancel',
            closeMessage: 'You are about to close the selected location.',
            closeLocation: 'Close location',
            closeLocationInNewScenario: 'Close location (in new scenario)',
            closeLocationInThisScenario: 'Close location (in current scenario)',
            closeLocationInNewNestedScenario: 'Close location (in new nested scenario)',
            selectedScenario: 'Selected scenario',

            nameRequired: 'Name is required',
            scenarioLocationsVisibleOnMap: 'Locations of scenarios',
            scenarios: 'Scenarios',
            errorOccured: 'An unexpected error has occurred, possibly due to a poor internet connection. Please press the refresh button to restart the application.',
            noTopScenariosFound: 'There are no top scenarios found. Create a new top scenario or edit an existing scenario to be a top scenario.',
            filterScenarios: 'Search on/within scenarios',
            locationInDefaultScenario: 'You cannot modify the default scenario. If you continue the location will be created in a new scenario with the same name as the location. Do you want to continue?',
            foundLocations: 'Found locations',
            generatedOn: 'Generated on',
            of: 'of',
            page: 'Page',
            selectAll: 'all',
            selectNone: 'none',
            heatMaps: 'Heat maps',
            print: 'Print',
            no: 'No',
            yes: 'Yes',
            copyChangesInformation: 'Please specify which changes you want to copy to the target scenario.',
            locations:'Locations',
            copyChanges: 'Copy changes',
            uploadLocationsCsv: 'Upload CSV',
            exportAreas: 'Export areas',
            exportAreasDialogTitle: 'Export areas',
            exportAreasInformation: 'Export the centroids of all areas matching the filters below. Use the export format selector in the menu to pick CSV or XLSX.',
            exportAreasAreaSet: 'Area set',
            exportAreasFilters: 'Area property filters (AND)',
            exportAreasAddFilter: 'Add filter',
            exportAreasRemoveFilter: 'Remove filter',
            exportAreasProperty: 'Property',
            exportAreasMinValue: 'Minimum',
            exportAreasMaxValue: 'Maximum',
            exportAreasNoNumericProperties: 'This area set has no numeric properties to filter on.',
            exportAreasRangeHint: 'Range in dataset: {min} – {max}',
            exportAreasTooManyRows: 'Export not possible: {count} rows exceeds the 100,000 limit. Tighten the filters.',
            exportAreasRowCountConfirm: 'This export will produce {count} rows. Continue?',
            exportAreasIncludeValues: 'Include area property values',
            exportAreasIncludeValuesHint: 'Off = faster: only Name, Longitude, Latitude and AreaCode are exported.',
            exportAreasButton: 'Export',
            uploadLocationsCsvInformation: 'Upload a CSV file with columns Name, Longitude, Latitude, LocationGroup. Correct any missing name or location group in the table.',
            uploadLocationsCsvEmpty: 'The CSV file is empty.',
            uploadLocationsCsvNoRows: 'No valid rows found in the CSV file.',
            uploadLocationsCsvMissingColumns: 'The CSV file is missing the Longitude or Latitude column.',
            uploadLocationsCsvInvalidRows: '{count} row(s) have a missing name or location group.',
            uploadLocationsCsvDetectedProperties: 'Location properties detected in CSV: {names}. Adjust values in the table if needed.',
            uploadLocationsCsvCultureMismatch: 'The CSV file appears to be in {detected} format, but {selected} is selected. Adjust the CSV language setting if needed.',
            selectCsvFile: 'Select CSV file',
            bulkUploadScenarioName: 'New locations',
            required: 'Required',
            longitude: 'Longitude',
            latitude: 'Latitude',
            locationGroup: 'Location group',
            nonShared: 'Non shared',
            sharedWith: 'Shared with',
            shared: 'Shared',
            otherLocations: 'other locations',
            mergeScenarioSource: 'The following changes will be merged into the selected scenario.',
            targetScenario: 'Target scenario',
            deleteSourceScenario: 'Delete source scenario',
            scenarioCompetition: 'Locations created in this scenario compete with other locations.',
            competitionDescription: 'Specifies if new locations within the scenario compete with other new locations.',
            isTopScenarioDescription: 'A top scenario specifies the scenario is listed first in the list of scenarios and is highlighted bold.',
            isTopScenario: 'Top scenario',
            mergeScenario: 'Merge scenario',
            confirmClose: 'Are you sure you want to close this dialog?',
            displayName: 'Displayname',
            email: 'E-mail address',
            mobilePhone: 'Mobile phone',
            calculationModel: 'Calculation model',
            calculateUnprocessedScenarios: 'Process unprocessed scenarios',
            log: 'Log',
            usage: 'Usage statistics',
            usageDescription: 'Shows activity per group. Pick one or more groups and a date range to see usage by action type. Optionally filter by one or more models.',
            groups: 'User groups',
            models: 'Models',
            users: 'Users',
            filter: 'Filter',
            dateRange: 'Date range',
            count: 'Count',
            distinctUsers: 'Distinct users',
            distinctActions: 'Distinct actions',
            groupBy: 'Group by',
            unknown: 'Unknown',
            noUsageData: 'No usage data found for this selection.',
            allActions: 'All actions',
            usageAction_fetchModel: 'Open model',
            usageAction_selectLocation: 'Select location',
            usageAction_calculate: 'Calculate',
            usageAction_createLocation: 'Create location',
            usageAction_updateLocation: 'Update location',
            usageAction_deleteLocation: 'Delete location',
            usageAction_createScenario: 'Create scenario',
            usageAction_updateScenario: 'Update scenario',
            usageAction_deleteScenario: 'Delete scenario',
            eventType: 'Type',
            source: 'Source',
            message: 'Message',
            warning: 'Warning',
            fetchIsoLine: 'Fetch isoline',
            isoLine: 'Isoline',
            scheduledDateTimeUtc: 'Scheduled',
            isoLinesMissingDateTimeUtc: 'Missing drive times',
            startedDateTimeUtc: 'Start',
            endedDateTimeUtc: 'End',
            noMatchingLocations: 'No matching locations',
            scenarioNameIsRequired: 'Scenario name is required',
            parentScenario: 'Parent scenario',
            sourceLocations: 'Source locations',
            sourceLocationsAllScenarios: 'Source locations all scenarios',
            driverFilterFunction: 'Function',
            driverFilterTitle: 'Title',
            addDriver: 'Add driver',
            addDriverFilter: 'Add group',
            confirmRemoveScenario: 'Are you sure you want to delete this scenario?',
            confirmRemoveLocation: 'Are you sure you want to delete this location?',
            confirmUndoCloseLocation: 'Are you sure you want to undo the closing of this location?',
            confirmUndoEditLocation: 'Are you sure you want to undo the editing of this location?',
            editScenario: 'Edit',
            removeScenario: 'Remove',
            calculateScenario: 'Calculate',

            filterAndSearch: 'Locations',
            map: 'Map',
            matchingPercentage: 'Matching %',
            drawerNotCalculated: 'The model is not calculated. Model results are unavailable.',
            drawerCalculating: 'The model is calculating. Wait for the results to be available.',
            legend: 'Legend',
            modelAdmin: 'Model owner',
            globalAdmin: 'Administrator',
            owner: 'Owner',
            ownerOnly: 'Owner only',
            noChanges: 'The are no openings or closures.',
            name: 'Name',
            query: 'Search text',
            coordinatesOrUrl: 'Coordinates or map URL',
            coordinatesOrUrlHint: 'e.g. 52.3676, 4.9041 or a Google / OSM / Bing / HERE link',
            invalidLocation: 'Could not read a coordinate from that input',
            export: 'Export',
            noDrivers: 'There are no drivers defined for this model.',
            condition: 'Condition',
            roundingDigits: 'Decimals',
            inverse: 'Inverse',
            drivers: 'Drivers',
            report: 'report',
            matchingLocationsOutputChart: 'Output diagram',
            matchingLocationsSimilarityChart: 'Radar diagram',
            driversChart: 'Drivers diagram',
            disclaimer :'Disclaimer',
            disclaimerContent: 'IRIS draws on the latest scientific methods, current point of sale information, market data, and consumer insights. Our predictive models are estimated with, and validated against, historical revenue data. Any predictive model, no matter how advanced, is a simplified representation of reality and thus will never achieve 100% accuracy. No rights can be derived from the model outputs.',
            help: 'Manual',
            csvExport: 'Export data',
            exportFormat: 'Export format',
            csv: 'CSV',
            xlsx: 'XLSX',
            fileFormatCulture: 'CSV language settings',
            dutchFormat: 'Dutch format',
            englishFormat: 'English format',
            areaInformation: 'Area information',
            areaInformationCatchmentArea: 'Area information catchment area',
            locationAreas: 'Areas of the location',
            adminPages: 'Admin',
            graphics: 'Charts',
            adminOnly: 'Only for administrators',
            
            scenarioProcessingLog: 'Processing log',
            calculationScheduled: 'Processing scheduled',
            calculationWaitingForIsolines: 'Processing waiting for isolines',
            calculationStarted: 'Processing started',
            calculationEnded: 'Processing ended',
            calculationScenarioError: 'Processing error (scenario)',
            calculationModelError: 'Processing error (model)',
            isolinesStarted: 'Isolines retrieval started',
            isolinesEnded: 'Isolines retrieval ended',
            isolinesError: 'Isolines retrieval error',
            isolinesBusy: 'Isolines retrieval busy',
            dateAndTime: 'Date and time',
            action: 'Action',
            model: 'Model',
            user: 'User',
            last100records: 'Last 100 records',
            propertiesChart: 'XY chart',
            propertyX: 'Property on X axis',
            propertyY: 'Property on Y axis',
            applicationTitle: 'IRIS',
            title: 'Title',
            logout: 'Logout',
            login:'Login',
            share: 'Share',
            area: 'Zipcode | Zipcodes',
            personType: 'Person type',
            inhabitants: 'Inhabitants',
            houseHolds: 'Housholds',
            income: 'Income',
            areaRevenuePerYear: 'Expense in zipcode per year',
            areaRevenuePerPeriod: 'Expense in zipcode per period',
            areaStandardConsumers: 'Standard consumers in zipcode',
            total: 'Total',
            travelTimeScores: 'Attractions travel time',
            from: 'from',
            calculation: 'Calculation',
            perYear: 'Per year',
            catchmentArea: 'Catchment area',
            outputSpending: 'Expense',
            outputNumber: 'Number',
            car: 'Car',
            pedestrian: 'Pedestrian',
            scorePersonType: 'Attraction person type',
            calculated: 'Calculated',
            location: 'Location',
            value: 'Value',
            defaultValue: 'Default value',
            expression: 'Function',
            format: 'Format',
            scoresLocationGroup: 'Attractions format',
            scoresShop: 'Attractions shop',
            scoresRetailArea: 'Attractions retail area',
            retailArea: 'Retail area',
            changedLocations: 'Changes',
            opening: 'Opening',
            closure: 'Closure',
            add:'Add',
            edit: "Edit",
            edited: "Edited",
            addScenario: 'Add scenario',
            infoScenario: 'Scenario information',
            info:'Information',
            calculate: 'Calculate',
            scenarioCreated: 'Creation date',
            scenarioModified: 'Edit date',
            scenarioCreatedBy: 'Created by',
            scenarioModifiedBy: 'Edited by',
            scenario: 'Scenario',
            scenarioName: 'Scenario name',
            save: 'Save',
            error: 'Error',
            url: 'URL',
            status: 'Status',
            description: 'Description',
            settings: 'Settings',
            new: 'New',
            modelParameters: 'Model parameters',
            scenarioReport: 'Impact report',
            editModelParameters: 'Edit model parameters',
            editDrivers: 'Edit drivers',
            propertyType: 'Type',
            drawerEmptyText: 'Click a location on the map to display information.',
            score: 'Attraction | Attractions',
            information: 'Information',
            layers: 'Layers',
            all: 'Everything',
            primary: 'Primary (50%)',
            secondary: 'Secondary (80%)',
            impact: 'Impact',
            impactCar: 'Impact car',
            impactPedestrian: 'Impact pedestrian',
            display: 'Display',
            top10: 'Top 10',
            top25: 'Top 25',
            top: 'Top',
            fraction: 'Share',
            fractionCumulative: 'Share (cumulative)',
            showTravelTimes: 'Show travel times',
            travelTimes: 'Travel times',
            minutes: 'Minutes',
            group: 'User group',
            property: 'Property',
            expressions: 'Expressions',
            powerFactor: 'Power factor',
            constant: 'Constant',
            scale: 'Scale',
            max: 'Maximum',
            fractionCutOffThreshold: 'Fraction cut off threshold',
            differenceDefaultScenario: 'Difference default scenario',
            reports: 'Reports',
            none: 'None',
            locationsType1Name: 'Location | Locations',
            locationsType2Name: 'Retail area | Retail areas',
            locationsType1FilterLocations: 'Filter on location of the scenario',
            locationsType2FilterLocations: 'Filter on retail area of the scenario',
            googleSearch: 'Search the map',
            locationType1Scores: 'Attractions location',
            locationType2Scores: 'Attractions retail area',
            areaScores: 'Attractions travel times',
            locationsType1Impact: 'Impact per location (top 25)',
            locationsType2Impact: 'Impact per retail area (top 25)',
            locationsGroupsType1Impact: 'Impact per format',
            locationsGroupsType2Impact: 'Impact per retail area type',
            locationsClustersType1Impact: 'Impact per retail area',
            locationsClustersType2Impact: 'Impact per municipality',
            locationsGroupsType1EmptyName: 'Independent',
            locationsGroupsType2EmptyName: '',
            locationsClustersType1EmptyName: '',
            locationsClustersType2EmptyName: '',
            locationGroupsType1Name: 'Format',
            locationGroupsType2Name: 'Retail area type',
            locationClustersType1Name: 'Retail area',
            locationClustersType2Name: 'Municipality',
            outputType1Name: "Turnover per week",
            outputType2Name: "Standard consumers",
            outputType3Name: "Turnover per year",
            outputType4Name: "Standard consumers",
            areasType1Name: "Zipcode | Zipcodes",
            areasType2Name: "Statistical sector | Statistical sectors",
            locationsType1New: "New location here",
            locationsType2New: "New retail area here",
            close: "Close",
            delete: "Delete",
            undoClose: "Undo close",
            undoEdit: "Undo edit",
            modelFunctionTypeToUse: "The following fields are possible to use:",
            ncalcMessage: "The functions are using the NCalc library. See https://github.com/ncalc/ncalc for more information.",
            calculationModelOutput: "Model results",
            locationsOutput: 'Locations',
            modelScenarioLocationsOutput: 'Model output',
            scenarioLocations: 'Locations',
            scenarioLocationsAllScenarios: 'Locations of all scenarios',
            scenarioLocationsOutput: 'Results',
            scenarioLocationsOutputDescription: 'Results of the selected scenario',
            scenarioLocationsOutputDescriptionWithHidden: 'Results of the selected scenario all fields',
            modelScenarioLocationsOutputDescription: 'Results of all processed scenarios',
            locationsOutputDescription: 'Locations.csv',
            catchmentAreaInformationExport: "Catchment area",
            catchmentAreaInformationExportCarDescription: "Catchment area car of the selected location",
            catchmentAreaInformationExportPedestrianDescription: "Catchment area pedestrian of the selected location",
            areaInformationExport: "Area result",
            areaInformationExportDescription: "Area result of the selected area",
            weight: "Weight",
            editNormalizedScoresFunctions: "Edit normalized scores functions",
            normalizedScoresFunctions: "Normalized scores functions",
            before: "Before",
            after: "After",
            difference: "Difference",
            localSituation: "Local situation",
            dontShow: "Don't show",
            pois: "POI's",
            poi: "POI",
            by:"by",
            matchingLocations: "Matching locations",
            scenarioStatusEdited: "Edited",
            scenarioStatusWaiting: "Waiting for processing",
            scenarioStatusProcessing: "Processing",
            scenarioStatusCompleted: "Completed",
            scenarioStatusCompletedWithErrors: "Completed with errors",
            pleaseLogin: "Please login using the upper right menu.",
            busyLoading: "Busy loading...",
            searchMap: "Search the map",
            unavailable: "Unavailable",
            show: "Show {item}",
            hide: "Hide {item}",
            dependencies: 'dependencies',
            agentIntro: "Hey I'm your personal IRIS AI-Agent. How may I help you?",
            agentQuestion: "Ask a question",
            agentTooltip: "Chat with the IRIS AI-Agent",
            agentDisclaimer: "I'm an AI-Agent and can make mistakes. Double check important information.",
            agentFilterAreasLocations: "You can see the areas and locations on the map",
            agentFilterLocations: "You can see the locations on the map",
            agentFilterAreas: "You can see the selected areas on the map",
            agentFilterAreaLocation: "You can see the area and the location on the map",
            agentFilterLocation: "You can see the location on the map",
            agentFilterArea: "You can see the selected area on the map",
            agentFilterAreasLocation: "You can see the areas and the location on the map",
            agentFilterAreaLocations: "You can see the area and the locations on the map",
            agentRemoveFilter: "I have removed the filters"

        }
    },
    de: {
        message: {

            locationPois: 'POIS von Standort',
            scenarioNotSelected: 'Kein Szenario ausgewählt',
            scenarioNotCalculated: 'Szenario wurde nicht berechnet',
            locationNotSelected: 'Kein Standort ausgewählt',
            catchmentAreaNotSelected: 'Kein Einzugsgebiet ausgewählt',

            exportMapToPng: 'Export map to PNG',
            satelliteView: 'Satellit',
            showLocationOutput: 'Modellergebnis anzeigen',
            googleStreetView: 'Google Streetview',
            googleMaps: 'Google Maps',
            selectedScenario: "Ausgewähltes Szenario",
            submodel: "Submodell",
            confirmCalculateScenario:
                "Das Szenario wurde geändert. Möchten Sie das Szenario berechnen?",
            search: "Auf der Karte suchen",
            scenarioNameAutomaticallyChangedNotificaton:
                "Der Name des Szenarios wurde automatisch angepasst, da nur noch eine Änderung vorhanden war.",
            scenarioDeletedBecauseEmptyNotificaton:
                "Das Szenario enthielt keine Änderungen mehr und wurde daher gelöscht.",
            setScenarioNameMessage:
                "Da Sie ein Szenario mit mehreren Änderungen erstellen, müssen Sie den Namen des Szenarios angeben.",
            setScenarioName: "Szenario Name",
            saveAddToNewScenario: "Speichern (in neuem Szenario)",
            saveAddToThisScenario: "Speichern (im aktuellen Szenario)",
            saveAddToNewNestedScenario:
                "Speichern (in neuem verschachteltem Szenario)",
            saveEditInNewScenario: "Speichern (in neuem Szenario)",
            saveEditInThisScenario: "Speichern (im aktuellen Szenario)",
            saveEditInNewNestedScenario:
                "Speichern (in neuem verschachteltem Szenario)",
            cancel: "Abbrechen",
            closeMessage: "Sie sind dabei, den Standort zu schließen.",
            closeLocation: "Standort schließen",
            closeLocationInNewScenario: "Standort schließen (in neuem Szenario)",
            closeLocationInThisScenario: "Standort schließen (im aktuellen Szenario)",
            closeLocationInNewNestedScenario:
                "Standort schließen (in neuem verschachteltem Szenario)",

            nameRequired: "Name ist erforderlich",
            scenarioLocationsVisibleOnMap: "Standorte der Szenarien",
            scenarios: "Szenarien",
            errorOccured:
                "Ups! Etwas ist schiefgelaufen. Ein unerwarteter Fehler ist aufgetreten, möglicherweise aufgrund einer schlechten Internetverbindung. Bitte schließen Sie diese Meldung und versuchen Sie die Aktion erneut. Wenn das Problem weiterhin besteht, aktualisieren Sie bitte die Seite. Wenn der Fehler weiterhin auftritt, überprüfen Sie Ihre Internetverbindung oder wenden Sie sich an den Support.",
            noTopScenariosFound:
                "Es wurden keine Top-Szenarien gefunden. Erstellen Sie ein neues Top-Szenario oder bearbeiten Sie ein bestehendes Szenario als Top-Szenario.",
            filterScenarios: "Nach/in Szenarien suchen",
            locationInDefaultScenario:
                "Sie können das Standardszenario nicht ändern. Wenn Sie fortfahren, wird der Standort in einem neuen Szenario mit demselben Namen wie der Standort erstellt. Möchten Sie fortfahren?",
            generatedOn: "Generiert am",
            foundLocations: "Gefundene Standorte",
            of: "von",
            page: "Seite",
            selectAll: "Alle",
            selectNone: "Keine",
            heatMaps: "Wärmekarte",
            print: "Drucken",
            no: "Nein",
            yes: "Ja",
            copyChangesInformation:
                "Bitte geben Sie an, welche Änderungen in das Zielszenario kopiert werden sollen.",
            locations: "Standorte",
            copyChanges: "Änderungen kopieren",
            uploadLocationsCsv: "CSV hochladen",
            exportAreas: "Gebiete exportieren",
            exportAreasDialogTitle: "Gebiete exportieren",
            exportAreasInformation: "Exportieren Sie die Schwerpunkte aller Gebiete, die den unten stehenden Filtern entsprechen. Wählen Sie das Exportformat (CSV oder XLSX) im Menü.",
            exportAreasAreaSet: "Gebietsmenge",
            exportAreasFilters: "Filter für Gebietseigenschaften (UND)",
            exportAreasAddFilter: "Filter hinzufügen",
            exportAreasRemoveFilter: "Filter entfernen",
            exportAreasProperty: "Eigenschaft",
            exportAreasMinValue: "Minimum",
            exportAreasMaxValue: "Maximum",
            exportAreasNoNumericProperties: "Diese Gebietsmenge hat keine numerischen Eigenschaften zum Filtern.",
            exportAreasRangeHint: "Bereich im Datensatz: {min} – {max}",
            exportAreasTooManyRows: "Export nicht möglich: {count} Zeilen überschreiten das Limit von 100.000. Filter anpassen.",
            exportAreasRowCountConfirm: "Dieser Export erzeugt {count} Zeilen. Fortfahren?",
            exportAreasIncludeValues: "Gebietseigenschaften einschließen",
            exportAreasIncludeValuesHint: "Aus = schneller: nur Name, Longitude, Latitude und AreaCode werden exportiert.",
            exportAreasButton: "Exportieren",
            uploadLocationsCsvInformation: "Laden Sie eine CSV-Datei mit den Spalten Name, Longitude, Latitude, LocationGroup hoch. Fehlender Name oder fehlende Standortgruppe können in der Tabelle korrigiert werden.",
            uploadLocationsCsvEmpty: "Die CSV-Datei ist leer.",
            uploadLocationsCsvNoRows: "Keine gültigen Zeilen in der CSV-Datei gefunden.",
            uploadLocationsCsvMissingColumns: "In der CSV-Datei fehlt die Spalte Longitude oder Latitude.",
            uploadLocationsCsvInvalidRows: "{count} Zeile(n) haben einen fehlenden Namen oder eine fehlende Standortgruppe.",
            uploadLocationsCsvDetectedProperties: "Standorteigenschaften aus CSV erkannt: {names}. Werte in der Tabelle bei Bedarf anpassen.",
            uploadLocationsCsvCultureMismatch: "Die CSV-Datei scheint im Format {detected} zu sein, aber {selected} ist ausgewählt. Passen Sie die CSV-Spracheinstellung bei Bedarf an.",
            selectCsvFile: "CSV-Datei auswählen",
            bulkUploadScenarioName: "Neue Standorte",
            required: "Erforderlich",
            longitude: "Längengrad",
            latitude: "Breitengrad",
            locationGroup: "Standortgruppe",
            nonShared: "Nicht geteilt",
            sharedWith: "Geteilt mit",
            shared: "Geteilt",
            otherLocations: "andere Standorte",
            mergeScenarioSource:
                "Die folgenden Änderungen werden mit dem angegebenen Szenario zusammengeführt.",
            targetScenario: "Zielszenario",
            deleteSourceScenario: "Quellenszenario löschen",
            competitionDescription:"Gibt an, ob neue Standorte innerhalb des Szenarios mit anderen neuen Standorten konkurrieren.",
            isTopScenarioDescription:
                "Ein Top-Szenario wird in der Liste der Szenarien zuerst und fett dargestellt.",
            mergeScenario: "Szenario zusammenführen",
            isTopScenario: "Top-Szenario",
            confirmClose:
                "Sind Sie sicher, dass Sie diesen Dialog schließen möchten?",
            displayName: "Anzeigename",
            email: "E-Mail-Adresse",
            mobilePhone: "Mobiltelefonnummer",
            calculationModel: "Berechnungsmodell",
            calculateUnprocessedScenarios: "Unverarbeitete Szenarien berechnen",
            log: "Protokoll",
            usage: "Nutzungsstatistik",
            usageDescription: "Zeigt Aktivitäten pro Gruppe. Wählen Sie eine oder mehrere Gruppen und einen Zeitraum, um die Nutzung nach Aktionstyp zu sehen. Optional nach einem oder mehreren Modellen filtern.",
            groups: "Benutzergruppen",
            models: "Modelle",
            users: "Benutzer",
            filter: "Filter",
            dateRange: "Zeitraum",
            count: "Anzahl",
            distinctUsers: "Eindeutige Benutzer",
            distinctActions: "Eindeutige Aktionen",
            groupBy: "Gruppieren nach",
            unknown: "Unbekannt",
            noUsageData: "Keine Nutzungsdaten für diese Auswahl gefunden.",
            allActions: "Alle Aktionen",
            usageAction_fetchModel: "Modell öffnen",
            usageAction_selectLocation: "Standort auswählen",
            usageAction_calculate: "Berechnen",
            usageAction_createLocation: "Standort erstellen",
            usageAction_updateLocation: "Standort aktualisieren",
            usageAction_deleteLocation: "Standort löschen",
            usageAction_createScenario: "Szenario erstellen",
            usageAction_updateScenario: "Szenario aktualisieren",
            usageAction_deleteScenario: "Szenario löschen",
            warning: "Warnung",
            eventType: "Typ",
            source: "Quelle",
            message: "Nachricht",
            fetchIsoLine: "Isochronen abrufen",
            isoLine: "Isochrone",
            scheduledDateTimeUtc: "Geplant",
            isoLinesMissingDateTimeUtc: "Fehlende Fahrzeiten",
            startedDateTimeUtc: "Start",
            endedDateTimeUtc: "Ende",
            noMatchingLocations: "Keine übereinstimmenden Standorte",
            scenarioNameIsRequired: "Szenario-Name ist erforderlich",
            parentScenario: "Quellenszenario",
            sourceLocations: "Quellstandorte",
            sourceLocationsAllScenarios: "Quellstandorte aller Szenarien",
            driverFilterFunction: "Funktion",
            driverFilterTitle: "Titel",
            addDriver: "Faktor hinzufügen",
            addDriverFilter: "Gruppe hinzufügen",
            confirmRemoveScenario:
                "Sind Sie sicher, dass Sie dieses Szenario löschen möchten?",
            confirmRemoveLocation:
                "Sind Sie sicher, dass Sie diesen Standort löschen möchten?",
            confirmUndoCloseLocation:
                "Sind Sie sicher, dass Sie das Schließen dieses Standorts rückgängig machen möchten?",
            confirmUndoEditLocation:
                "Sind Sie sicher, dass Sie die Bearbeitung dieses Standorts rückgängig machen möchten?",
            editScenario: "Bearbeiten",
            removeScenario: "Entfernen",
            calculateScenario: "Berechnen",
            calculateThisScenario: "Berechnen szenario",
            filterAndSearch: "Standorte",
            map: "Karte",
            matchingPercentage: "Übereinstimmung %",
            drawerNotCalculated:
                "Das Modell wurde nicht berechnet. Die Modellergebnisse sind nicht verfügbar.",
            drawerCalculating:
                "Das Modell wird berechnet. Warten Sie, bis die Ergebnisse verfügbar sind.",
            legend: "Legende",
            modelAdmin: "Modelleigentümer",
            globalAdmin: "Administrator",
            owner: "Eigentümer",
            ownerOnly: "Nur für Eigentümer",
            noChanges: "Es gibt keine Öffnungen oder Schließungen.",
            name: "Name",
            query: "Suchtext",
            coordinatesOrUrl: "Koordinaten oder Karten-URL",
            coordinatesOrUrlHint: "z. B. 52.3676, 4.9041 oder ein Google / OSM / Bing / HERE Link",
            invalidLocation: "Aus dieser Eingabe konnte keine Koordinate gelesen werden",
            export: "Exportieren",
            noDrivers: "Für dieses Modell sind keine Faktoren definiert.",
            condition: "Bedingung",
            roundingDigits: "Dezimalstellen",
            inverse: "Invers",
            drivers: "Faktoren",
            report: "Bericht",
            matchingLocationsOutputChart: "Ergebnisdiagramm",
            matchingLocationsSimilarityChart: "Radar-Diagramm",
            driversChart: "Faktordiagramm",
            disclaimer: "Haftungsausschluss",
            disclaimerContent:
                "Die Entwicklung von IRIS basiert auf wissenschaftlichen Methoden, aktuellen Verkaufsstelleninformationen und sorgfältig recherchierten und aktuellen Kundeninformationen. Das Modell wird so gut wie möglich anhand der tatsächlich am Markt erzielten Umsätze und Informationen über das Funktionieren des Marktes validiert. Jedes mathematische Modell, wie detailliert es auch ausgearbeitet sein mag, ist eine vereinfachte Darstellung der Realität und wird niemals 100 % korrekt sein. Aus den Ergebnissen können daher keine Rechte abgeleitet werden.",
            help: "Handbuch",
            csvExport: "Daten exportieren",
            exportFormat: "Exportformat",
            csv: "CSV",
            xlsx: "XLSX",
            fileFormatCulture: "CSV-Spracheinstellungen",
            dutchFormat: "Niederländisches Format",
            englishFormat: "Englisches Format",
            areaInformation: "Gebietsinformationen",
            areaInformationCatchmentArea: "Gebietsinformationen Einzugsgebiet",

            adminPages: "Admin",
            locationAreas: "Gebiete des Standorts",
            adminOnly: "Nur für Administratoren (FUNKTIONIERT NOCH NICHT)",
            scenarioCompetition:
                "Standorte in diesem Szenario konkurrieren miteinander.",
            scenarioProcessingLog: "Verarbeitungsprotokoll",
            calculationScheduled: "Verarbeitung geplant",
            calculationWaitingForIsolines: "Verarbeitung wartet auf Isochronen",
            calculationStarted: "Verarbeitung gestartet",
            calculationEnded: "Verarbeitung beendet",
            calculationScenarioError: "Verarbeitungsfehler (Szenario)",
            calculationModelError: "Verarbeitungsfehler (Modell)",
            isolinesStarted: "Isochronenabruf gestartet",
            isolinesEnded: "Isochronenabruf beendet",
            isolinesError: "Isochronenabruf fehlgeschlagen",
            isolinesBusy: "Isochronenabruf läuft",
            dateAndTime: "Datum und Uhrzeit",
            action: "Aktion",
            model: "Modell",
            user: "Benutzer",
            last100records: "Letzte 100 Einträge",
            propertiesChart: "XY-Diagramm",
            propertyX: "Eigenschaft auf X-Achse",
            propertyY: "Eigenschaft auf Y-Achse",
            tree: "Baum",
            applicationTitle: "IRIS",
            title: "Titel",
            logout: "Abmelden",
            login: "Anmelden",
            share: "Anteil",
            area: "Gebiet | Gebiete",
            personType: "Persona",
            inhabitants: "Einwohner",
            houseHolds: "Haushalte",
            income: "Einkommen",
            areaRevenuePerYear: "Ausgaben in Postleitzahl pro Jahr",
            areaRevenuePerPeriod: "Ausgaben in Postleitzahl pro Zeitraum",
            areaStandardConsumers: "Standardkonsumenten in Postleitzahl",
            total: "Gesamt",
            travelTimeScores: "Attraktivität Reisezeit",
            from: "von",
            calculation: "Berechnung",
            perYear: "Pro Jahr",
            catchmentArea: "Einzugsgebiet",
            outputSpending: "Ausgaben",
            outputNumber: "Anzahl",
            car: "Auto",
            pedestrian: "Fußgänger",
            scorePersonType: "Attraktivität Persona",
            calculated: "Berechnet",
            location: "Standort",
            value: "Wert",
            defaultValue: "Standardwert",
            expression: "Funktion",
            format: "Format",
            scoresLocationGroup: "Attraktivität Format",
            scoresShop: "Attraktivität Geschäft",
            scoresRetailArea: "Attraktivität Einzelhandelsgebiet",
            retailArea: "Einzelhandelsgebiet",
            changedLocations: "Änderungen",
            opening: "Eröffnung",
            closure: "Schließung",
            edited: "Bearbeitet",
            edit: "Bearbeiten",
            addScenario: "Szenario hinzufügen",
            infoScenario: "Szenarioinformationen",
            calculate: "Berechnen",
            add: "Hinzufügen",
            info: "Information",
            scenarioCreated: "Erstellungsdatum",
            scenarioModified: "Bearbeitungsdatum",
            scenarioCreatedBy: "Erstellt von",
            scenarioModifiedBy: "Bearbeitet von",
            scenario: "Szenario",
            scenarioReport: "Auswirkungsbericht",
            scenarioName: "Szenarioname",
            save: "Speichern",
            error: "Fehler",
            url: "URL",
            status: "Status",
            description: "Beschreibung",
            settings: "Einstellungen",
            new: "Neu",
            modelParameters: "Modellparameter",
            none: "Keine",
            editModelParameters: "Modellparameter bearbeiten",
            editDrivers: "Faktoren bearbeiten",
            propertyType: "Typ",
            drawerEmptyText:
                "Klicken Sie auf einen Standort auf der Karte, um Informationen anzuzeigen.",
            score: "Attraktivität | Attraktivitäten",
            information: "Informationen",
            graphics: "Diagramme",
            layers: "Ebenen",
            all: "Alle",
            primary: "Primär (50%)",
            secondary: "Sekundär (80%)",
            impact: "Auswirkung",
            impactCar: "Auswirkung Auto",
            impactPedestrian: "Auswirkung Fußgänger",
            display: "Anzeige",
            top10: "Top 10",
            top25: "Top 25",
            top: "Top",
            fraction: "Anteil",
            fractionCumulative: "Anteil (kumulativ)",
            showTravelTimes: "Reisezeiten anzeigen",
            travelTimes: "Reisezeiten",
            minutes: "Minuten",
            group: "Benutzergruppe",
            property: "Eigenschaft",
            expressions: "Funktionen",
            powerFactor: "Potenzfaktor",
            constant: "Konstante",
            scale: "Skala",
            max: "Maximum",
            by: "von", // Or "durch", depending on context
            fractionCutOffThreshold: "Schwellenwert für den Anteil",
            differenceDefaultScenario: "Unterschied zum Standardszenario",
            reports: "Berichte",
            locationsType1Name: "Standort | Standorte",
            locationsType2Name: "Einzelhandelsgebiet | Einzelhandelsgebiete",
            locationsType1FilterLocations: "Nach Standort des Szenarios filtern",
            locationsType2FilterLocations:
                "Nach Einzelhandelsgebiet des Szenarios filtern",
            googleSearch: "Auf der Karte suchen",
            locationType1Scores: "Attraktivität Standort",
            locationType2Scores: "Attraktivität Einzelhandelsgebiet",
            areaScores: "Attraktivität Reisezeiten",
            locationsType1Impact: "Auswirkung pro Standort (Top 25)",
            locationsType2Impact: "Auswirkung pro Einzelhandelsgebiet (Top 25)",
            locationGroupsType1Name: "Format",
            locationGroupsType2Name: "Art des Einzelhandelsgebiets",
            locationsGroupsType1Impact: "Auswirkung pro Format (Top 10)",
            locationsGroupsType2Impact:
                "Auswirkung pro Art des Einzelhandelsgebiets (Top 10)",
            locationsClustersType1Impact:
                "Auswirkung pro Einzelhandelsgebiet (Top 10)",
            locationsClustersType2Impact: "Auswirkung pro Gemeinde (Top 10)",
            locationsClustersType1EmptyName: "",
            locationsClustersType2EmptyName: "",
            locationsGroupsType1EmptyName: "Unabhängig",
            locationsGroupsType2EmptyName: "",
            locationClustersType1Name: "Einzelhandelsgebiet",
            locationClustersType2Name: "Gemeinde",
            outputType1Name: "Umsatz pro Woche",
            outputType2Name: "Standardkonsumenten",
            outputType3Name: "Umsatz pro Jahr",
            outputType4Name: "Standardkonsumenten",
            areasType1Name: "Postleitzahl | Postleitzahlen",
            areasType2Name: "Statistischer Sektor | Statistische Sektoren",
            locationsType1New: "Neuer Standort hier",
            locationsType2New: "Neues Einzelhandelsgebiet hier",
            close: "Schließen",
            delete: "Löschen",
            undoClose: "Schließen rückgängig machen",
            undoEdit: "Bearbeitung rückgängig machen",
            modelFunctionTypeToUse: "Die folgenden Felder können verwendet werden:",
            ncalcMessage:
                "Die Funktionen verwenden die NCalc-Bibliothek. Weitere Informationen finden Sie unter https://github.com/ncalc/ncalc.",
            calculationModelOutput: "Modellergebnisse",
            locationsOutput: "Standorte",
            modelScenarioLocationsOutput: 'Ergebnisse',
            scenarioLocationsOutput: "Ergebnisse",
            scenarioLocations: "Standorte",
            scenarioLocationsAllScenarios: "Standorte aller Szenarien",
            scenarioLocationsOutputDescription:
                "Ergebnisse des ausgewählten Szenarios",
            modelScenarioLocationsOutputDescription: 'Ergebnisse aller verarbeiteten Szenarien',
            scenarioLocationsOutputDescriptionWithHidden:
                "Ergebnisse des ausgewählten Szenarios (alle Felder)",
            locationsOutputDescription: "Locations.csv",
            catchmentAreaInformationExport: "Einzugsgebiet",
            catchmentAreaInformationExportCarDescription:
                "Einzugsgebiet Auto des ausgewählten Standorts",
            

            catchmentAreaInformationExportPedestrianDescription:
                "Einzugsgebiet Fußgänger des ausgewählten Standorts",
            areaInformationExport: "Gebietsergebnis",
            areaInformationExportDescription:
                "Gebietsergebnis des ausgewählten Gebiets",
            weight: "Gewichtung",
            editNormalizedScoresFunctions:
                "Funktionen für normalisierte Werte bearbeiten",
            normalizedScoresFunctions: "Funktionen für normalisierte Werte",
            before: "Vorher",
            after: "Nachher",
            difference: "Differenz",
            localSituation: "Lokale Situation",
            dontShow: "Nicht anzeigen",
            pois: "POIs",
            poi: "POI",
            matchingLocations: "Übereinstimmende Standorte",
            scenarioStatusEdited: "Bearbeitet",
            scenarioStatusWaiting: "Wartend auf Verarbeitung",
            scenarioStatusProcessing: "In Bearbeitung",
            scenarioStatusCompleted: "Abgeschlossen",
            scenarioStatusCompletedWithErrors: "Abgeschlossen mit Fehlern",
            pleaseLogin: "Bitte melden Sie sich über das Menü oben rechts an.",
            busyLoading: "Laden...",
            searchMap: "Karte durchsuchen",
            unavailable: "Nicht verfügbar",
            show: "{item} anzeigen",
            hide: "{item} verbergen",
            dependencies: 'Abhängigkeiten',
            agentIntro: "Hallo, ich bin Ihr persönlicher IRIS AI-Agent. Wie kann ich Ihnen helfen?",
            agentQuestion: "Eine Frage stellen",
            agentTooltip: "Chatten Sie mit dem IRIS AI-Agent",
            agentDisclaimer: "Ich bin ein AI-Agent und kann Fehler machen. Bitte überprüfen Sie die wichtigen Informationen.",
            agentFilterAreasLocations: "Sie können die Bereiche und Standorte auf der Karte sehen",
            agentFilterLocations: "Sie können die Standorte auf der Karte sehen",
            agentFilterAreas: "Sie können die ausgewählten Bereiche auf der Karte sehen",
            agentFilterAreaLocation: "Sie können den Bereich und den Standort auf der Karte sehen",
            agentFilterLocation: "Sie können den Standort auf der Karte sehen",
            agentFilterArea: "Sie können den ausgewählten Bereich auf der Karte sehen",
            agentFilterAreasLocation: "Sie können die Bereiche und den Standort auf der Karte sehen",
            agentFilterAreaLocations: "Sie können den Bereich und die Standorte auf der Karte sehen",
            agentRemoveFilter: "Ich habe die Filter entfernt"
        },
    }
}
export default messages;